module.exports = __webpack_public_path__ + "static/img/person.beed027c.png";